import {useEffect, useState} from "react";
import { AppEntities } from "src/config/entities";
import { ImportsService } from "src/services/documents/ImportsService";
import { ImportDto } from "../dtos/IImportsDto";
import {toast} from "react-toastify";
import { IImportModel } from "../model/IImportModel";
import { TypeHelper } from "src/helpers/TypeHelper";
import { IAdditionalDocumentsModel } from "../model/IAdditionalDocumentsModel";
import { ICustomCostsModel } from "../model/CustomsCostsModel";
import { IExciseDutiesModel } from "../model/IExciseDutiesModel";
import { IImportTaxModel } from "../model/IImportTaxModel";
import { IVatsModel } from "../model/IVatsModel";

interface IProps {
    documentId?: string;
}

export const useFetchImport = ({documentId}: IProps) => {
    const [isDocumentLoading, setIsDocumentLoading] = useState(false);
    const [documentDto, setDocumentDto] = useState<ImportDto | null>(null);
    const [documentModel, setDocumentModel] = useState<IImportModel | null>(null);
    const dataService = AppEntities.Imports.getDataService() as ImportsService;

    const postDocument = async () => {
        if (!documentId) return;
        await dataService.PostDocument(documentId);
        toast.success("Document posted successfully");
    }

    const cancelDocument = async () => {
        if (!documentId) return;
        await dataService.CancelDocument(documentId);
        toast.success("Document canceled successfully");
    }
    
    const updateDocument = async (documentModel: IImportModel) => {
        if (!documentId) return;
       
        const requestDto: ImportDto = {...documentModel};
        const responseDto = await dataService.Update(requestDto);
        setDocumentDto(responseDto);
    }

    const fetchDocument = async () => {
        try {
            setIsDocumentLoading(true);

            console.log("documentId", documentId);

            let responseDto: ImportDto | null = null;
            let responseAdditionalDto: IAdditionalDocumentsModel[] = [];
            let responseCustomCostDto: ICustomCostsModel[] = [];
            let responseExciseDutiesDto: IExciseDutiesModel[] = [];
            let responseTaxDto: IImportTaxModel[] = [];
            let responseVatsDto: IVatsModel[] = [];

            if (!documentId) {
                responseDto = await dataService.Create({
                    documentDate: new Date(),
                });
                setDocumentDto(responseDto);
            } else {
                responseDto = await dataService.Get(documentId);
                setDocumentDto(responseDto);
            }
            
            if (!responseDto) return;
            
            const newModel: IImportModel = {
                ...responseDto,
                additionalDocuments: [...responseAdditionalDto],
                customCostsDto: [...responseCustomCostDto],
                exciseDuties: [...responseExciseDutiesDto],
                importTaxs: [...responseTaxDto],
                vats: [...responseVatsDto],
            };
            setDocumentModel(newModel);
        } catch (e) {
            console.log(e);
        } finally {
            setIsDocumentLoading(false);
        }
    }

    useEffect(() => {
        fetchDocument();
    }, [documentId]);

    return {
        isDocumentLoading,
        documentDto,
        documentModel,
        postDocument,
        cancelDocument,
        updateDocument
    }
}